<template>
  <form
    class="store-form"
    action="#"
    method="post"
    @submit.prevent="handleSubmitAddress"
  >
    <input
      v-model="address"
      :placeholder="placeholder"
      inputmode="numeric"
      pattern="^(?(^00000(|-0000))|(\d{5}(|-\d{4})))$"
      class="map-input"
    >
    <button
      class="search"
      type="submit"
    >
      OK
    </button>
  </form>
</template>

<script>
import { gmapApi } from 'vue2-google-maps';

export default {
  data() {
    return {
      address: '',
      map: null,
    };
  },
  computed: {
    placeholder() {
      return this.$config.store.placeholder;
    },
    geocoder() {
      return new this.google.maps.Geocoder();
    },
    google: gmapApi,
  },
  mounted() {
  },
  methods: {
    handleSubmitAddress() {
      this.geocoder.geocode({ address: `${this.address} France` }, (results) => {
        this.$emit('searchMap', results);
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
$typo = @block {
  font-family: $mainFont;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 1px
}

.store-form {
  display: flex;
  flex-direction: row;
  justify-content: center;
  border: 1px solid black;
  background-color: black;
  border-radius: 7px

  input {
    { $typo }
    height: 43px;
    background-color: $cl-blue;;
    padding: 0 10px 0 10px;
    border-radius: 6px 0 0 6px;
    border: none;
    color: white;
    line-height: 16px;
    margin: 0;
    outline: 1px solid transparent

    +mobile() {
      width: calc(100% - 56px);
    }

    +desktop() {
      width: 250px;
      margin: 0;
    }

    &::placeholder {
      color: white;
    }
  }

  button {
    { $typo }
    font-weight: 700;
    width: 56px; height: 43px;
    background-color: white;
    color: $cl-blue;
    border-radius: 0 6px 6px 0
    vertical-align: top;
    margin: 0;
    transition: all 0.3s;
    cursor: pointer;
    +hover(){
      background-color: $cl-blue;
      color: white;
    }
  }
}
</style>

